export default "__VITE_ASSET__Cn3Rvihn__"